import React from 'react'

export default class AnimatedTagline extends React.PureComponent {
  render () {
    return (
      <div className='animated-tagline-container'>
        <div className='animated-tagline'>
          <div className='animated-scroller'>
            <span className='animated-tagline-verb'>
              <span>Acquire</span>
              <span>Activate</span>
              <span>Engage</span>
            </span>
            <div className='animated-tagline-verb-underline' />
          </div>
          more customers.
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/animated-tagline.js